export type CreateStripeConnectAccountDto = {
    businessId: number;
};

export type CheckOnboardingDto = {
    onboarded: boolean;
    onboardingLink?: string;
};


export type StripeConnectLoginLink = {
    url: string;    
}

export type CreateProductDto = {
    name: string;
    description?: string;
    price: number;
    imageUrl?: string;
}

export type UpdateProductDto = CreateProductDto;

export type ProductDto = CreateProductDto & {
    id: string;
    numberOfRequests: number;
    totalRevenue: number;
    totalRevenueCollected: number;
    createdAt: Date;
    updatedAt: Date;
}

export type PaymentLinkDto = {
    paymentLink: string;
}

export enum PaymentRequestType {
  ONLY_MARKABLE = 'ONLY_MARKABLE',
  OPP = 'OPP',
  SC_LINK = 'SC_LINK',
  SC_CHECKOUT_INTENT = 'SC_CHECKOUT_INTENT',
  SC_SINGLE_DIRECT_DEBIT = 'SC_SINGLE_DIRECT_DEBIT',
  SC_DIRECT_DEBIT = 'SC_DIRECT_DEBIT',
}

export interface C2BOrderCreateDto {
    customerId: number;
    productId: string;
    quantity?: number;
    paymentRequestType: PaymentRequestType;
}

export type C2BOrderDto = C2BOrderCreateDto & {
    c2bOrderId: number;
    paymentOrderId: number;
    customerName: string;
    veraLink: string;
    amount: number;
    status: PaymentOrderStatus;
    createdAt: Date;
    updatedAt: Date;
    type: ProductType;
};

enum ProductType {
  MISC = 'MISC',
  EVENT_TICKET = 'EVENT_TICKET',
  CONTRIBUTION = 'CONTRIBUTION',
}

export interface C2BOrderMetaOutDto {
    userId: number;
    totalOrders: number;
    totalAmount: number;
    totalCollected: number;
}


export enum PaymentOrderStatus {
  PENDING='PENDING',
  PAID='PAID',
  CANCELLED='CANCELLED',
  FAILED='FAILED',
  AUTHORIZED='AUTHORIZED',
  TO_BE_REFUNDED='TO_BE_REFUNDED',
  REFUNDED='REFUNDED',
}

export interface PayoutTransactionDto {
    orderId: number;
    paymentAmount: number;
    faceValueAmount: number;
    currency: string;
    description: string;
    stripeFeeAmount: number;
    veraFeeAmount: number;
    netAmount: number;
    productName: string;
    productType: ProductType;
    customerName: string;
    mutationId: number;
    status: PaymentOrderStatus;
    updatedAt: Date;
    payoutDate: Date;
    payoutId: string;
}

export interface PayoutDetails {
    id: string;
    date: string;
    totalAmount: number;
    totalIncomingTransactions: number;
    totalFees: number;
    numberOfTransactions: number;
}

export interface PayoutPaymentDetails {
    id: number;
    memberName: string;
    product: string;
    received: number;
    stripeFee: number;
    veraFee: number;
};

export type PayoutDetailsWithPayments = PayoutDetails & {
    individualPayments: PayoutPaymentDetails[];
};

export interface PayoutsMetadata {
    totalPayouts: number;
    totalAmount: number;
    totalFees: number;
    totalIncomingTransactions: number;
}